<div class="cards-container">
    <ng-container *ngFor="let insurance of insurances">
        <div class="insurance-card ccc ccc-hover d-flex flex-column align-items-center text-center flex-grow-1 animated-col" 
            (click)="navigateToDetailHandler(insurance.insuranceId)"              
            role="button">
            <div class="mb-3">
                <dynamic-field [props]="props?.ContractNumber" [canBeEmpty]="true">
                    <span HJSuppress class="insurance-contract-number fw-bold">
                        {{ insurance.contractNumber | replaceIfNull }}
                    </span>
                </dynamic-field>
            </div>
            <div class="insurance-type">        
                <dynamic-field [props]="props?.InsuranceType" [canBeEmpty]="true">
                    <div HJSuppress class="fs-5">
                        {{ insurance.insuranceType | replaceIfNull }}
                    </div>
                </dynamic-field>  
            </div>
            <div class="insurance-number mb-2">
                <dynamic-field [props]="props?.InsuranceNumber" [canBeEmpty]="true" 
                    *ngIf="insurance.insuranceNumber">
                    <span  class="card-label">{{'insurance.insuranceList.insuranceNumber' | translate}}</span> 
                    <span HJSuppress class="fw-semibold">
                        {{insurance.insuranceNumber | replaceIfNull }}
                    </span>
                </dynamic-field>
            </div>
            <div class="insurance-company mb-2">
                <dynamic-field [props]="props?.InsuranceCompany" [canBeEmpty]="true">
                    <span HJSuppress class="fs-5 card-label fw-semibold">
                        {{insurance.insuranceCompany | replaceIfNull }}
                    </span>  
                </dynamic-field>
            </div>
            <div class="insurance-value mb-3">
                <dynamic-field [props]="props?.Value" [canBeEmpty]="true">
                    <span HJSuppress class="fs-4 fw-bold">
                        {{ insurance.value ? (insurance.value | number : '1.') + " " + insurance.currencyCode : '-' }}
                    </span>
                </dynamic-field>
            </div>
            <div class="insurance-date mb-3">
                <div class="date-label">
                    {{ 'contracts.contractPeriod' | translate }}
                </div>
                <div class="d-flex align-items-center justify-content-center gap-3">
                    <dynamic-field [props]="props?.StartDate" [canBeEmpty]="true">
                        <div HJSuppress class="fw-bold">{{ insurance.startDate| localizedDate }}</div>
                    </dynamic-field>
                    <i class="app-icon icon icon-arrow-right icon-lg"></i>
                    <dynamic-field [props]="props?.EndDate" [canBeEmpty]="true">
                        <div HJSuppress class="fw-bold">{{ insurance.endDate| localizedDate }}</div>
                    </dynamic-field>
                </div>
            </div>
            <dynamic-field [props]="props.Status" [canBeEmpty]="true">
                <div class="insurance-status-box">
                    <div class="insurance-status-dot" 
                        [ngClass]="'status-'+(insurance.status).toLowerCase()"
                    >
                    </div>
                    <div class="insurance-status-value">
                        {{ 'insurance.insuranceList.insuranceStatus.'+(insurance.status).toLowerCase() | translate }}
                    </div>
                </div>
            </dynamic-field>   
        </div>
    </ng-container>
</div>